import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material';
import HomeRepository from '../../data/repository/HomeRespository';

const AgeVerificationDialog = () => {
      
  const { t } = useTranslation();
  const [location, setLocation] = useState("AR");
  const [isOpen, setIsOpen] = useState(false);
  const homeRepository = new HomeRepository();

  useEffect(() => {
    const isAgeVerified = localStorage.getItem('ageVerified');
    if (!isAgeVerified) {
      getLocation();
    }
  }, []);

  const getLocation = async () => {
    try {
      const response = await homeRepository.getLocation();
      setLocation(response?.location);
      setIsOpen(true);
    } catch (error) {
      setLocation("AR");
      setIsOpen(true);
    }
  };

  const handleConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setIsOpen(false);
  };

  const handleDeny = () => {
    window.location.href = "https://www.google.com";
  };

  return (
      <Dialog open={isOpen} onClose={handleDeny} aria-labelledby="age-verification-title">
        <DialogTitle sx={{ backgroundColor: '#160F31', color: 'white' }} id="age-verification-title">
          {t(location === "US" ? 'ageVerification.us.title' : 'ageVerification.title')}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: '#160F31', color: 'white' }}>
          {t(location === "US" ? 'ageVerification.us.sentence1' : 'ageVerification.sentence1')}
        </DialogContent>
        <DialogActions sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row'}, gap: '0.75rem', backgroundColor: '#160F31', justifyContent: 'space-between' }}>
          <Button sx={{ width: { xs: '100%', sm: '50%' }}} onClick={handleDeny} className={"btn-gradient"}>
            {t(location === "US" ? 'ageVerification.us.sentence2' : 'ageVerification.sentence2')}
          </Button>
          <Button sx={{ width: { xs: '100%', sm: '50%' }}} onClick={handleConfirm} className={"gradient-border-button"} style={{color: 'white'}}>
            {t(location === "US" ? 'ageVerification.us.sentence3' : 'ageVerification.sentence3')}
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default AgeVerificationDialog;
